'use client';

import React from 'react';
import { LicenseInformation } from '~/types/licenses';

type LicenseDescriptionProps = {
  license_information: LicenseInformation;
};

export const LicenseDescription: React.FC<LicenseDescriptionProps> = ({
  license_information,
}) => {
  const { name, information_list } = license_information;

  if (!information_list || information_list.length === 0) return null;

  return (
    <div className="u-pl10 u-pr10">
      <div className="c-panel">
        <h2 className="c-panel__header">{name}の求人の特徴</h2>
        <div className="c-panel__body">
          <div className="p-job-search__feature">
            <div className="p-job-search__feature__content">
              {information_list.map((info, idx) => (
                <React.Fragment key={idx}>
                  <p className="u-font-bold p-job-search__feature__title">
                    {info.title}
                  </p>
                  <p dangerouslySetInnerHTML={{ __html: info.description }} />
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LicenseDescription;
